import React from "react";
import ReactDOM from "react-dom";
import {FeaturedProjects} from "../components/FeaturedProjects";

export const insertFeaturedProjects = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="featured-projects"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<FeaturedProjects />, element);
  });
};
